/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClassificationTier
 */
export interface ClassificationTier {
    /**
     * The unique identifier of the classification tier
     * @type {string}
     * @memberof ClassificationTier
     */
    id?: string | null;
    /**
     * The key of the classification tier
     * @type {string}
     * @memberof ClassificationTier
     */
    key: string;
    /**
     * The name of the classification tier
     * @type {string}
     * @memberof ClassificationTier
     */
    name?: string | null;
    /**
     * The description of the classification tier
     * @type {string}
     * @memberof ClassificationTier
     */
    description?: string | null;
    /**
     * The position of the classification tier
     * @type {number}
     * @memberof ClassificationTier
     */
    position: number;
}

/**
 * Check if a given object implements the ClassificationTier interface.
 */
export function instanceOfClassificationTier(value: object): value is ClassificationTier {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    return true;
}

export function ClassificationTierFromJSON(json: any): ClassificationTier {
    return ClassificationTierFromJSONTyped(json, false);
}

export function ClassificationTierFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClassificationTier {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'key': json['key'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'position': json['position'],
    };
}

export function ClassificationTierToJSON(json: any): ClassificationTier {
    return ClassificationTierToJSONTyped(json, false);
}

export function ClassificationTierToJSONTyped(value?: ClassificationTier | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'key': value['key'],
        'name': value['name'],
        'description': value['description'],
        'position': value['position'],
    };
}

